import * as dotProp from 'dot-prop-immutable';

import { createReducer } from '@topconagriculture/frontend-utils';

import { createRelation, deleteRelation, getRelations, updateRelation } from './relations.actions';
import { Relation } from './relations.types';

export type RelationsState = Relation[];

const initialState: RelationsState = [];

const relationsReducer = createReducer(initialState, {
  [getRelations.done.type]: (_state: RelationsState, action: ReturnType<typeof getRelations.done>) =>
    action.payload.result,
  [createRelation.done.type]: (state: RelationsState, action: ReturnType<typeof createRelation.done>) => [
    ...state,
    action.payload.result,
  ],
  [updateRelation.done.type]: (state: RelationsState, action: ReturnType<typeof updateRelation.done>) => {
    const updatedRelation = action.payload.result;
    const indexFound = state.findIndex((relation) => relation.id === updatedRelation.id);
    return dotProp.set(state, indexFound, updatedRelation);
  },
  [deleteRelation.done.type]: (state: RelationsState, action: ReturnType<typeof deleteRelation.done>) => {
    const deletedRelationId = action.payload.result;
    const indexFound = state.findIndex((relation) => relation.id === deletedRelationId);
    return dotProp.delete(state, indexFound);
  },
});

export default relationsReducer;
